import { render, staticRenderFns } from "./UserCategories.vue?vue&type=template&id=2b38c2c0&"
import script from "./UserCategories.vue?vue&type=script&lang=js&"
export * from "./UserCategories.vue?vue&type=script&lang=js&"
import style0 from "./UserCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VCard,VCardTitle,VChip,VChipGroup})
